import { rect, cRect } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

// Big head, short body — cute proportions
export const body_chibi: Hull = {
  id: 'body_chibi',
  name: 'Chibi',
  drawBody: (ctx, p) => {
    // Big head (20 wide, 18 tall)
    rect(ctx, 22, 4, 20, 18, p.light);
    rect(ctx, 22, 4, 1, 18, p.shadow);
    rect(ctx, 41, 4, 1, 18, p.shadow);
    rect(ctx, 23, 4, 18, 1, p.shadow);
    rect(ctx, 23, 21, 18, 1, p.shadow);
    // Neck
    rect(ctx, 30, 22, 4, 2, p.light);
    // Shoulders
    cRect(ctx, 24, 14, 2, p.light);
    // Arms
    rect(ctx, 23, 26, 4, 8, p.light);
    rect(ctx, 37, 26, 4, 8, p.light);
    // Short torso (10 wide, 8 tall)
    rect(ctx, 27, 26, 10, 8, p.light);
    rect(ctx, 27, 26, 1, 8, p.shadow);
    rect(ctx, 36, 26, 1, 8, p.shadow);
    // Hips
    rect(ctx, 27, 34, 10, 2, p.shadow);
    // Short chubby legs
    rect(ctx, 26, 36, 5, 10, p.light);
    rect(ctx, 26, 36, 1, 10, p.shadow);
    rect(ctx, 33, 36, 5, 10, p.light);
    rect(ctx, 37, 36, 1, 10, p.shadow);
  },
  mounts: {
    [SLOT.HEAD]:   { anchor: { x: 32, y: 4 } },
    [SLOT.FACE]:   { anchor: { x: 32, y: 11 } },
    [SLOT.HAT]:    { anchor: { x: 32, y: 4 } },
    [SLOT.TORSO]:  { anchor: { x: 32, y: 24 } },
    [SLOT.WAIST]:  { anchor: { x: 32, y: 34 } },
    [SLOT.FOOT_L]: { anchor: { x: 28, y: 45 } },
    [SLOT.FOOT_R]: { anchor: { x: 36, y: 45 } },
  },
};
